import PropTypes from "prop-types";
import UserProductRatingsContainer from "../user_product_ratings/user-product-ratings-container";
import PDPPrice from "./pdp-price";
import { analytics, flagsAndExperimentNames } from "rtr-constants";
import { useSelector } from "react-redux";
import MembershipHelpers from "helpers/membership-helpers";
import AtomRetailPrice from "../atoms/atom-retail-price";
import { withOnLoadFlagsAndExperiments } from "components/source/hoc/with-flags-and-experiments.jsx";

const propTypes = {
  analyticsLoggingContext: PropTypes.object,
  annotationSuffix: PropTypes.string,
  isHeartEducationTooltipTriggered: PropTypes.bool,
  isMembershipUpsellView: PropTypes.bool,
  isRentable: PropTypes.bool,
  isRetailOnly: PropTypes.bool,
  membershipPricing: PropTypes.array,
  product: PropTypes.object.isRequired,
  rentalText: PropTypes.string,
  showPurchasePrice: PropTypes.bool,
  canRenderSplitTheBusiness: PropTypes.bool,
  userData: PropTypes.object,
};

function PDPHeader(props) {
  const { product, userData, canRenderSplitTheBusiness } = props;
  const atbTabExp = useSelector(state => state.flagsAndExperiments?.[flagsAndExperimentNames.RSV_1494_ATB_TABS]);

  if (!product) return null;

  const { designer = {}, displayName } = product;

  const renderHeart = () => {
    return !canRenderSplitTheBusiness || MembershipHelpers.isClassicLens(userData) ? (
      <div className="product-rating-container__wrapper -mr-3">
        <UserProductRatingsContainer
          customHeartLoggingOptions={props.analyticsLoggingContext}
          isHeartEducationTooltipTriggered={props.isHeartEducationTooltipTriggered}
          product={product}
          location={analytics.ACTION_LOCATIONS.PDP}
        />
      </div>
    ) : null;
  };

  return (
    <div className="pdp-header">
      <div className="flex justify-between items-center">
        <h1 className="font-sans text-md text-darkerGray pb-2" itemProp="name" aria-label="Product Name">
          {displayName}
        </h1>
        {renderHeart()}
      </div>
      <h2 className="font-sans text-h4 underline pb-2">
        <a href={"/designers/" + designer.id + "?source=pdp"}>{designer.displayName}</a>
      </h2>

      {atbTabExp ? (
        <AtomRetailPrice
          designerId={product?.designer?.id}
          showPurchasePrice={true}
          showPurchasePriceDiscount={true}
          hideRetailValue={true}
          supressRetailValueCopy={true}
          purchasePrice={product?.purchasePrice}
          product={product}
          retailPrice={product?.retailPrice}
        />
      ) : (
        <PDPPrice
          annotationSuffix={props.annotationSuffix}
          isMembershipUpsellView={props.isMembershipUpsellView}
          isRentable={props.isRentable}
          isRetailOnly={props.isRetailOnly}
          membershipPricing={props.membershipPricing}
          product={props.product}
          rentalText={props.rentalText}
          showPurchasePrice={props.showPurchasePrice}
        />
      )}
    </div>
  );
}

PDPHeader.propTypes = propTypes;

export default withOnLoadFlagsAndExperiments(flagsAndExperimentNames.RSV_1494_ATB_TABS)(PDPHeader);
